import { render, staticRenderFns } from "./addProgress.vue?vue&type=template&id=58678336&scoped=true&"
import script from "./addProgress.vue?vue&type=script&lang=js&"
export * from "./addProgress.vue?vue&type=script&lang=js&"
import style0 from "./addProgress.vue?vue&type=style&index=0&id=58678336&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58678336",
  null
  
)

export default component.exports